import { render, staticRenderFns } from "./Daoshu2.vue?vue&type=template&id=13c62094&"
import script from "./Daoshu2.vue?vue&type=script&lang=js&"
export * from "./Daoshu2.vue?vue&type=script&lang=js&"
import style0 from "./Daoshu2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports